import { createFileRoute } from '@tanstack/react-router'
import { WebhookDetail } from '@/features/webhooks/detail'

function WebhookDetailRoute() {
  const { webhookId } = Route.useParams()
  return <WebhookDetail webhookId={webhookId} />
}

export const Route = createFileRoute('/webhooks_/$webhookId')({
  component: WebhookDetailRoute,
})
